<div class="container-fluid">
  <div class="header-container">
    <div class="row justify-content-start mb-2">
      <div class="col-12">
        <span class="iso-header ml-2">
          {{ "bikeshop.menu.other_settings" | translate }}
        </span>
      </div>
    </div>
  </div>

  <div class="settings-layout">
    <!-- Left Sidebar with Vertical Tabs -->
    <div class="settings-sidebar">
      <div class="settings-tab"
           [class.active]="activeSection === 'workshop-insights'"
           (click)="setActiveSection('workshop-insights')">
        <daz-icon name="report" size="18px" [color]="activeSection === 'workshop-insights' ? '#FFFFFF' : '#6B7280'"></daz-icon>
        <span>{{ "bikeshop.shop_profile.workshop_insights" | translate }}</span>
      </div>

      <div class="settings-tab"
           [class.active]="activeSection === 'workshop-settings'"
           (click)="setActiveSection('workshop-settings')">
        <daz-icon name="settings-gear" size="18px" [color]="activeSection === 'workshop-settings' ? '#FFFFFF' : '#6B7280'"></daz-icon>
        <span>{{ "settings.workshop_settings" | translate}}</span>
      </div>

      <div class="settings-tab"
           [class.active]="activeSection === 'workshop-notifications'"
           (click)="setActiveSection('workshop-notifications')">
        <daz-icon name="bell" size="18px" [color]="activeSection === 'workshop-notifications' ? '#FFFFFF' : '#6B7280'"></daz-icon>
        <span>{{ "bikeshop.shop_profile.workshop_notifications" | translate }}</span>
      </div>

      <div class="settings-tab"
           [class.active]="activeSection === 'messaging-options'"
           (click)="setActiveSection('messaging-options')">
        <daz-icon name="mail-alt-1" size="18px" [color]="activeSection === 'messaging-options' ? '#FFFFFF' : '#6B7280'"></daz-icon>
        <span>{{ "bikeshop.shop_profile.messaging_options" | translate }}</span>
      </div>

      <div class="settings-tab"
           [class.active]="activeSection === 'calendar-options'"
           (click)="setActiveSection('calendar-options')">
        <daz-icon name="calendar" size="18px" [color]="activeSection === 'calendar-options' ? '#FFFFFF' : '#6B7280'"></daz-icon>
        <span>{{ "bikeshop.shop_profile.calendar_options" | translate }}</span>
      </div>

      <div class="settings-tab"
           [class.active]="activeSection === 'technician-goals'"
           (click)="setActiveSection('technician-goals')">
        <daz-icon name="people" size="18px" [color]="activeSection === 'technician-goals' ? '#FFFFFF' : '#6B7280'"></daz-icon>
        <span>{{ "bikeshop.shop_profile.technician_hourly_labour_goals" | translate }}</span>
      </div>

      <div class="settings-tab"
           [class.active]="activeSection === 'jobcard-options'"
           (click)="setActiveSection('jobcard-options')">
        <daz-icon name="clipboard" size="18px" [color]="activeSection === 'jobcard-options' ? '#FFFFFF' : '#6B7280'"></daz-icon>
        <span>{{ "bikeshop.shop_profile.jobcard_options" | translate }}</span>
      </div>

      <div class="settings-tab"
           [class.active]="activeSection === 'collection-options'"
           (click)="setActiveSection('collection-options')">
        <daz-icon name="truck" size="18px" [color]="activeSection === 'collection-options' ? '#FFFFFF' : '#6B7280'"></daz-icon>
        <span>{{ "bikeshop.shop_profile.collection_options" | translate }}</span>
      </div>

      <div class="settings-tab"
           [class.active]="activeSection === 'special-orders'"
           (click)="setActiveSection('special-orders')"
           *ngIf="partner.POSSystemID === 6">
        <daz-icon name="shopping-cart" size="18px" [color]="activeSection === 'special-orders' ? '#FFFFFF' : '#6B7280'"></daz-icon>
        <span>{{ "bikeshop.shop_profile.special_orders" | translate }}</span>
      </div>

      <div class="settings-tab"
           [class.active]="activeSection === 'inventory-management'"
           (click)="setActiveSection('inventory-management')">
        <daz-icon name="box-archive" size="18px" [color]="activeSection === 'inventory-management' ? '#FFFFFF' : '#6B7280'"></daz-icon>
        <span>{{ "bikeshop.shop_profile.inventory_management" | translate }}</span>
      </div>

      <div class="settings-tab"
           [class.active]="activeSection === 'printing-options'"
           (click)="setActiveSection('printing-options')">
        <daz-icon name="printer" size="18px" [color]="activeSection === 'printing-options' ? '#FFFFFF' : '#6B7280'"></daz-icon>
        <span>{{ "bikeshop.shop_profile.printing_options" | translate }}</span>
      </div>

      <div class="settings-tab"
           [class.active]="activeSection === 'shopride-options'"
           (click)="setActiveSection('shopride-options')">
        <daz-icon name="bike" size="18px" [color]="activeSection === 'shopride-options' ? '#FFFFFF' : '#6B7280'"></daz-icon>
        <span>{{ "bikeshop.shop_profile.shopride_options" | translate }}</span>
      </div>
    </div>

    <!-- Right Content Area -->
    <div class="settings-content">
      <div *ngIf="ShopForm">
        <form [formGroup]="ShopForm" (ngSubmit)="savePartner(ShopForm.value)" (keydown.enter)="$event.preventDefault()">

          <!-- Workshop Insights Section -->
          <div class="settings-section" *ngIf="activeSection === 'workshop-insights'">
            <div class="section-header">
              <h3>{{ "bikeshop.shop_profile.workshop_insights" | translate }}</h3>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.workshop_insights.productivityandefficiency.receive_emails" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="SendInsightDailyEmail"></p-inputSwitch>
                  <small style="margin-left: 8px; margin-top: auto; margin-bottom: auto;">
                    {{ "bikeshop.shop_profile.workshop_insights.productivityandefficiency.receive_emails_info"| translate : {email: partner.eMail} }}
                  </small>
                </div>
              </div>
            </div>

            <div class="row margin-top-8" *ngIf="ShopForm.value.SendInsightDailyEmail">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.workshop_insights.productivityandefficiency.receive_emails_recipients" | translate }}:
              </div>
              <div class="col-md-3">
                <div class="p-inputgroup">
                  <input type="text" pInputText formControlName="ServiceInsightEmailAddresses" />
                </div>
              </div>
              <div class="col-md-5" style="padding-left:0px;">
                <div class="p-inputgroup">
                  <small style="margin-top: auto; margin-bottom: auto;">
                    {{ "bikeshop.shop_profile.workshop_insights.productivityandefficiency.receive_emails_recipients_info" | translate }}
                  </small>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.workshop_insights.finances.receive_emails" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="SendFinanceInsightEmail"></p-inputSwitch>
                  <small style="margin-left: 8px; margin-top: auto; margin-bottom: auto;">
                    {{ "bikeshop.shop_profile.workshop_insights.finances.receive_emails_info"| translate : {email: partner.eMail} }}
                  </small>
                </div>
              </div>
            </div>

            <div class="row margin-top-8" *ngIf="ShopForm.value.SendFinanceInsightEmail">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.workshop_insights.finances.receive_emails_recipients" | translate }}:
              </div>
              <div class="col-md-3">
                <div class="p-inputgroup">
                  <input type="text" pInputText formControlName="ServiceFinanceInsightEmailAddresses" />
                </div>
              </div>
              <div class="col-md-5" style="padding-left:0px;">
                <div class="p-inputgroup">
                  <small style="margin-top: auto; margin-bottom: auto;">
                    {{ "bikeshop.shop_profile.workshop_insights.finances.receive_emails_recipients_info" | translate }}
                  </small>
                </div>
              </div>
            </div>
          </div>

          <!--Workshop Settings section-->
          <div class="settings-section" *ngIf="activeSection === 'workshop-settings'">

            <!-- Bay Management -->
            <div class="section-header">
              <h3>{{ "settings.configured.bays_mangement" | translate }}</h3>
            </div>

            <div class="management-sub-header">{{ "settings.configured.bays" | translate }}</div>

            <div class="management-list">
              <div *ngFor="let bay of bays; let i = index" class="management-list-item">
                <ng-container *ngIf="!bay.editing">
                  <span class="management-item-name">{{bay.name}}</span>
                  <div class="management-list-actions">
                    <hub-button [size]="'lg'" [style]="'outline'" [icon]="'pencil'" (buttonClick)="editBay(bay)"></hub-button>
                    <hub-button [size]="'lg'" [style]="'outline'" [icon]="'trash'" (buttonClick)="deleteBay(bay, i)"></hub-button>
                    <!--<button pButton type="button" icon="pi pi-pencil" class="p-button-text p-button-sm management-icon-btn" (click)="editBay(bay)"></button>
                    <button pButton type="button" icon="pi pi-trash" class="p-button-text p-button-sm management-icon-btn" (click)="deleteBay(bay, i)"></button>-->
                  </div>
                </ng-container>
                <ng-container *ngIf="bay.editing">
                  <input maxlength="20" type="text" pInputText [(ngModel)]="bay.editValue" [ngModelOptions]="{standalone: true}" class="management-edit-input" (keyup.enter)="saveBay(bay)" />
                  <div class="management-list-actions">
                    <hub-button *ngIf="bay.editValue.trim().length > 0 && checkUniqueBays(bay.editValue)" [size]="'lg'" [style]="'outline'" [icon]="'check'" (buttonClick)="saveBay(bay)"></hub-button>
                    <hub-button [size]="'lg'" [style]="'outline'" [icon]="'cross'" (buttonClick)="cancelBayEdit(bay, i)"></hub-button>
                    <!--<button pButton type="button" icon="pi pi-check" class="p-button-text p-button-sm management-icon-btn" (click)="saveBay(bay)"></button>
                    <button pButton type="button" icon="pi pi-times" class="p-button-text p-button-sm management-icon-btn" (click)="cancelBayEdit(bay, i)"></button>-->
                  </div>
                </ng-container>
              </div>
            </div>

            <div *ngIf="!disableAddBays" class="add-management-link" (click)="addBay()">+ {{ 'settings.configured.bays_add' | translate }}</div>
             
            <!-- Tag Management -->
            <div class="section-header management-section-separator">
              <h3>{{ 'settings.configured.tags_mangement' | translate }}</h3>
            </div>

            <div class="management-sub-header">{{ 'settings.configured.tags' | translate }}</div>

            <div class="management-list">
              <div *ngFor="let tag of tags; let i = index" class="management-list-item">
                <ng-container *ngIf="!tag.editing">
                  <span class="management-item-name">{{tag.name}}</span>
                  <div class="management-list-actions">
                    <hub-button [size]="'lg'" [style]="'outline'" [icon]="'pencil'" (buttonClick)="editTag(tag)"></hub-button>
                    <hub-button [size]="'lg'" [style]="'outline'" [icon]="'trash'" (buttonClick)="deleteTag(tag, i)"></hub-button>
                  </div>
                </ng-container>
                <ng-container *ngIf="tag.editing">
                  <input type="text" maxlength="50" pInputText [(ngModel)]="tag.editValue" [ngModelOptions]="{standalone: true}" class="management-edit-input" (keyup.enter)="saveTag(tag) " />
                  <div class="management-list-actions">
                    <hub-button *ngIf="tag.editValue.trim().length > 0 && checkUniqueTags(tag.editValue)" [size]="'lg'" [style]="'outline'" [icon]="'check'" (buttonClick)="saveTag(tag)"></hub-button>
                    <hub-button [size]="'lg'" [style]="'outline'" [icon]="'cross'" (buttonClick)="cancelTagEdit(tag, i)"></hub-button>
                  </div>
                </ng-container>
              </div>
            </div>

            <div *ngIf="!disableAddTags" class="add-management-link" (click)="addTag()">+ {{ 'settings.configured.tags_add' | translate}}</div>

          </div>

          <!-- Workshop Notifications Section -->
          <div class="settings-section" *ngIf="activeSection === 'workshop-notifications'">
            <div class="section-header">
              <h3>{{ "bikeshop.shop_profile.workshop_notifications" | translate }}</h3>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.send_notification_on_booking" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="SendNotificationOnBooking"></p-inputSwitch>
                  <small style="margin-left: 8px; margin-top: auto; margin-bottom: auto;">
                    {{ "bikeshop.shop_profile.send_notification_on_booking_info" | translate : {email: partner.eMail} }}
                  </small>
                </div>
              </div>
            </div>

            <div class="row margin-top-8" *ngIf="ShopForm.value.SendNotificationOnBooking">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.service_notification_recipients" | translate }}:
              </div>
              <div class="col-md-3">
                <div class="p-inputgroup">
                  <input type="text" pInputText formControlName="ServiceNotificationsAddresses" />
                </div>
              </div>
              <div class="col-md-5" style="padding-left:0px;">
                <div class="p-inputgroup">
                  <small style="margin-top: auto; margin-bottom: auto;">
                    {{ "bikeshop.shop_profile.service_notification_recipients_info" | translate }}
                  </small>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.send_fitting_notification_on_booking" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="SendNotificationOnFittingBooking"></p-inputSwitch>
                  <small style="margin-left: 8px; margin-top: auto; margin-bottom: auto;">
                    {{ "bikeshop.shop_profile.send_fitting_notification_on_booking_info" | translate : {email: partner.eMail} }}
                  </small>
                </div>
              </div>
            </div>

            <div class="row margin-top-8" *ngIf="ShopForm.value.SendNotificationOnFittingBooking">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.fitting_notification_recipients" | translate }}:
              </div>
              <div class="col-md-3">
                <div class="p-inputgroup">
                  <input type="text" pInputText formControlName="FittingNotificationsAddresses" />
                </div>
              </div>
              <div class="col-md-5" style="padding-left:0px;">
                <div class="p-inputgroup">
                  <small style="margin-top: auto; margin-bottom: auto;">
                    {{ "bikeshop.shop_profile.fitting_notification_recipients_info" | translate }}
                  </small>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.send_daily_workshop_summary" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="SendDailySummaryReport" (onChange)="setDailySummaryReportState()"></p-inputSwitch>
                  <small style="margin-left: 8px; margin-top: auto; margin-bottom: auto;">
                    {{ "bikeshop.shop_profile.send_daily_workshop_summary_info" | translate : {email: partner.eMail} }}
                  </small>
                </div>
              </div>
            </div>

            <div class="row margin-top-8" *ngIf="ShopForm.value.SendDailySummaryReport">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.daily_workshop_summary_recipients" | translate }}:
              </div>
              <div class="col-md-3">
                <div class="p-inputgroup">
                  <input type="text" pInputText formControlName="DailySummaryReportRecipients" />
                </div>
              </div>
              <div class="col-md-5" style="padding-left:0px;">
                <div class="p-inputgroup">
                  <small style="margin-top: auto; margin-bottom: auto;">
                    {{ "bikeshop.shop_profile.daily_workshop_summary_recipients_info" | translate }}
                  </small>
                </div>
              </div>
            </div>
          </div>

          <!-- Messaging Options Section -->
          <div class="settings-section" *ngIf="activeSection === 'messaging-options'">
            <div class="section-header">
              <h3>{{ "bikeshop.shop_profile.messaging_options" | translate }}</h3>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.send_service_reminder_before_service" | translate }}:
              </div>
              <div class="col-md-2">
                <div class="p-inputgroup">
                  <input type="number" pInputText formControlName="ReminderHoursBeforeService" placeholder="{{ 'bikeshop.shop_profile.send_service_reminder_before_service' | translate }}" />
                </div>
              </div>
              <div class="col-md-6" style="padding-left:0px;">
                <div class="p-inputgroup">
                  <small style="margin-top: auto; margin-bottom: auto;">
                    {{ "bikeshop.shop_profile.send_service_reminder_before_service_info" | translate }}
                  </small>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.post_service_followup" | translate }}:
              </div>
              <div class="col-md-2">
                <div class="p-inputgroup">
                  <input type="number" pInputText formControlName="PostServiceFollowUpDays" placeholder="{{ 'bikeshop.shop_profile.bikeshop.shop_profile.post_service_followup_info' | translate }}" />
                </div>
              </div>
              <div class="col-md-6" style="padding-left:0px;">
                <div class="p-inputgroup">
                  <small style="margin-top: auto; margin-bottom: auto;">
                    {{ "bikeshop.shop_profile.post_service_followup_info" | translate }}
                  </small>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.send_service_reminder_post_service" | translate }}:
              </div>
              <div class="col-md-2">
                <div class="p-inputgroup">
                  <input type="number" pInputText formControlName="ServiceFollowUpReminderMonths" placeholder="{{ 'bikeshop.shop_profile.send_service_reminder_post_service_info' | translate }}" />
                </div>
              </div>
              <div class="col-md-6" style="padding-left:0px;">
                <div class="p-inputgroup">
                  <small style="margin-top: auto; margin-bottom: auto;">
                    {{ "bikeshop.shop_profile.send_service_reminder_post_service_info" | translate }}
                  </small>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.send_other_service_reminder_post_service" | translate }}:
              </div>
              <div class="col-md-2">
                <div class="p-inputgroup">
                  <input type="number" pInputText formControlName="OtherServiceFollowUpReminderMonths" placeholder="{{ 'bikeshop.shop_profile.send_other_service_reminder_post_service_info' | translate }}" />
                </div>
              </div>
              <div class="col-md-6" style="padding-left:0px;">
                <div class="p-inputgroup">
                  <small style="margin-top: auto;margin-bottom: auto;">
                    {{ "bikeshop.shop_profile.send_other_service_reminder_post_service_info" | translate }}
                  </small>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">{{ "service.bikenotcollected_title" | translate }}:</div>
              <div class="col-md-2">
                <div class="p-inputgroup">
                  <input type="number" pInputText formControlName="BikeNotCollectedFollowUpDays" />
                </div>
              </div>
              <div class="col-md-6" style="padding-left:0px;">
                <div class="p-inputgroup">
                  <small style="margin-top: auto;margin-bottom: auto;">
                    {{ "service.bikenotcollected_description" | translate }}
                  </small>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">{{ "service.bikenotcollectedreminder_title" | translate }}:</div>
              <div class="col-md-2">
                <div class="p-inputgroup">
                  <input type="number" pInputText formControlName="BikeNotCollectedFollowUpReminderDays" />
                </div>
              </div>
              <div class="col-md-6" style="padding-left:0px;">
                <div class="p-inputgroup">
                  <small style="margin-top: auto;margin-bottom: auto;">
                    {{ "service.bikenotcollectedreminder_description" | translate }}
                  </small>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">{{ "service.deliverynotbooked_title" | translate }}:</div>
              <div class="col-md-2">
                <div class="p-inputgroup">
                  <input type="number" pInputText formControlName="DeliveryNotBookedFollowUpDays" />
                </div>
              </div>
              <div class="col-md-6" style="padding-left:0px;">
                <div class="p-inputgroup">
                  <small style="margin-top: auto;margin-bottom: auto;">
                    {{ "service.deliverynotbooked_description" | translate }}
                  </small>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">{{ "service.deliverynotbookedreminder_title" | translate }}:</div>
              <div class="col-md-2">
                <div class="p-inputgroup">
                  <input type="number" pInputText formControlName="DeliveryNotBookedReminderFollowUpDays" />
                </div>
              </div>
              <div class="col-md-6" style="padding-left:0px;">
                <div class="p-inputgroup">
                  <small style="margin-top: auto;margin-bottom: auto;">
                    {{ "service.deliverynotbookedreminder_description" | translate }}
                  </small>
                </div>
              </div>
            </div>
          </div>



          <!-- Calendar Options Section -->
          <div class="settings-section" *ngIf="activeSection === 'calendar-options'">
            <div class="section-header">
              <h3>{{ "bikeshop.shop_profile.calendar_options" | translate }}</h3>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.customise_status_labels_colours" | translate }}:
              </div>
              <div class="col-md-8 status-update-container">
                <div>
                  <div>{{ 'bikeshop.statuses.to_pick_up' | translate }}</div>
                  <div>
                    <div><input maxlength="30" type="text" pInputText formControlName="PickupLabel" placeholder="{{'bikeshop.shop_profile.change_status_label' | translate}}" /></div>
                    <div class="color-picker-custom" [ngStyle]="{ 'background-color' : ShopForm.value.PickupsColor }" [(colorPicker)]="ShopForm.value.PickupsColor" cpOutputFormat="hex" cpAlphaChannel="disabled"></div>
                  </div>
                </div>
                <div>
                  <div>{{ 'bikeshop.statuses.booked_in' | translate }}</div>
                  <div>
                    <div><input maxlength="30" type="text" pInputText formControlName="BookedInLabel" placeholder="{{'bikeshop.shop_profile.change_status_label' | translate}}" /></div>
                    <div class="color-picker-custom" [ngStyle]="{ 'background-color' : ShopForm.value.BookedInColor }" [(colorPicker)]="ShopForm.value.BookedInColor" cpOutputFormat="hex" cpAlphaChannel="disabled"></div>
                  </div>
                </div>
                <div>
                  <div>{{ 'bikeshop.statuses.assigned' | translate }}</div>
                  <div>
                    <div><input maxlength="30" type="text" pInputText formControlName="WaitingForWorkLabel" placeholder="{{'bikeshop.shop_profile.change_status_label' | translate}}" /></div>
                    <div class="color-picker-custom" [ngStyle]="{ 'background-color' : ShopForm.value.WaitingForWorkColor }" [(colorPicker)]="ShopForm.value.WaitingForWorkColor" cpOutputFormat="hex" cpAlphaChannel="disabled"></div>
                  </div>
                </div>
                <div>
                  <div>{{ 'bikeshop.statuses.working_on' | translate }}</div>
                  <div>
                    <div><input maxlength="30" type="text" pInputText formControlName="WorkingOnLabel" placeholder="{{'bikeshop.shop_profile.change_status_label' | translate}}" /></div>
                    <div class="color-picker-custom" [ngStyle]="{ 'background-color' : ShopForm.value.WorkingOnColor }" [(colorPicker)]="ShopForm.value.WorkingOnColor" cpOutputFormat="hex" cpAlphaChannel="disabled"></div>
                  </div>
                </div>
                <div>
                  <div>{{ 'bikeshop.statuses.warranty' | translate }}</div>
                  <div>
                    <div><input maxlength="30" type="text" pInputText formControlName="WarrantyLabel" placeholder="{{'bikeshop.shop_profile.change_status_label' | translate}}" /></div>
                    <div class="color-picker-custom" [ngStyle]="{ 'background-color' : ShopForm.value.WarrantyColor }" [(colorPicker)]="ShopForm.value.WarrantyColor" cpOutputFormat="hex" cpAlphaChannel="disabled"></div>
                  </div>
                </div>
                <div>
                  <div>{{ 'bikeshop.statuses.waiting_parts' | translate }}</div>
                  <div>
                    <div><input maxlength="30" type="text" pInputText formControlName="WaitingForPartsLabel" placeholder="{{'bikeshop.shop_profile.change_status_label' | translate}}" /></div>
                    <div class="color-picker-custom" [ngStyle]="{ 'background-color' : ShopForm.value.WaitingForPartsColor }" [(colorPicker)]="ShopForm.value.WaitingForPartsColor" cpOutputFormat="hex" cpAlphaChannel="disabled"></div>
                  </div>
                </div>
                <div>
                  <div>{{ 'bikeshop.statuses.waiting_client' | translate }}</div>
                  <div>
                    <div><input maxlength="30" type="text" pInputText formControlName="WaitingForClientLabel" placeholder="{{'bikeshop.shop_profile.change_status_label' | translate}}" /></div>
                    <div class="color-picker-custom" [ngStyle]="{ 'background-color' : ShopForm.value.WaitingForClientColor }" [(colorPicker)]="ShopForm.value.WaitingForClientColor" cpOutputFormat="hex" cpAlphaChannel="disabled"></div>
                  </div>
                </div>
                <div>
                  <div>{{ 'bikeshop.statuses.bike_ready' | translate }}</div>
                  <div>
                    <div><input maxlength="30" type="text" pInputText formControlName="CompletedLabel" placeholder="{{'bikeshop.shop_profile.change_status_label' | translate}}" /></div>
                    <div class="color-picker-custom" [ngStyle]="{ 'background-color' : ShopForm.value.BikeReadyColor }" [(colorPicker)]="ShopForm.value.BikeReadyColor" cpOutputFormat="hex" cpAlphaChannel="disabled"></div>
                  </div>
                </div>
                <div>
                  <div>{{ 'bikeshop.statuses.collected' | translate }}</div>
                  <div>
                    <div><input maxlength="30" type="text" pInputText formControlName="CollectedLabel" placeholder="{{'bikeshop.shop_profile.change_status_label' | translate}}" /></div>
                    <div class="color-picker-custom" [ngStyle]="{ 'background-color' : ShopForm.value.CollectedColor }" [(colorPicker)]="ShopForm.value.CollectedColor" cpOutputFormat="hex" cpAlphaChannel="disabled"></div>
                  </div>
                </div>
                <div>
                  <div>{{ 'bikeshop.statuses.to_deliver' | translate }}</div>
                  <div>
                    <div><input maxlength="30" type="text" pInputText formControlName="DeliveryLabel" placeholder="{{'bikeshop.shop_profile.change_status_label' | translate}}" /></div>
                    <div class="color-picker-custom" [ngStyle]="{ 'background-color' : ShopForm.value.DeliveryColor }" [(colorPicker)]="ShopForm.value.DeliveryColor" cpOutputFormat="hex" cpAlphaChannel="disabled"></div>
                  </div>
                </div>
                <div>
                  <div>{{ 'bikeshop.statuses.cancelled' | translate }}</div>
                  <div>
                    <div><input maxlength="30" type="text" pInputText formControlName="CancelledLabel" placeholder="{{'bikeshop.shop_profile.change_status_label' | translate}}" /></div>
                    <div style="width: 23px"></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.show_custom_status_on_job_card" | translate }}:
              </div>
              <div class="col-md-1">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="ShowINeedHelp" (onChange)="setINeedHelpState()"></p-inputSwitch>
                </div>
              </div>
            </div>

            <div class="row margin-top-8" *ngIf="ShopForm.value.ShowINeedHelp">
              <div class="col-md-4 label">
                
              </div>
              <div class="col-md-8 status-update-container">
                <div>
                  <div>
                    <div><input maxlength="30" type="text" pInputText formControlName="INeedHelpLabel" placeholder="{{'bikeshop.shop_profile.change_status_label' | translate}}" /></div>
                    <div *ngIf="ShopForm.value.INeedHelpLabel && ShopForm.value.INeedHelpLabel.trim().length > 0" class="color-picker-custom" [ngStyle]="{ 'background-color' : ShopForm.value.INeedHelpColor }" [(colorPicker)]="ShopForm.value.INeedHelpColor" cpOutputFormat="hex" cpAlphaChannel="disabled"></div>
                  </div>
                </div>
                <div>
                  <div>
                    <div><input maxlength="30" type="text" pInputText formControlName="CustomLabelOne" placeholder="{{'bikeshop.shop_profile.change_status_label' | translate}}" /></div>
                    <div *ngIf="ShopForm.value.CustomLabelOne && ShopForm.value.CustomLabelOne.trim().length > 0" class="color-picker-custom" [ngStyle]="{ 'background-color' : ShopForm.value.CustomColourOne }" [(colorPicker)]="ShopForm.value.CustomColourOne" cpOutputFormat="hex" cpAlphaChannel="disabled"></div>
                  </div>
                </div>
                <div>
                  <div>
                    <div><input maxlength="30" type="text" pInputText formControlName="CustomLabelTwo" placeholder="{{'bikeshop.shop_profile.change_status_label' | translate}}" /></div>
                    <div *ngIf="ShopForm.value.CustomLabelTwo && ShopForm.value.CustomLabelTwo.trim().length > 0" class="color-picker-custom" [ngStyle]="{ 'background-color' : ShopForm.value.CustomColourTwo }" [(colorPicker)]="ShopForm.value.CustomColourTwo" cpOutputFormat="hex" cpAlphaChannel="disabled"></div>
                  </div>
                </div>
                <div>
                  <div>
                    <div><input maxlength="30" type="text" pInputText formControlName="CustomLabelThree" placeholder="{{'bikeshop.shop_profile.change_status_label' | translate}}" /></div>
                    <div *ngIf="ShopForm.value.CustomLabelThree && ShopForm.value.CustomLabelThree.trim().length > 0" class="color-picker-custom" [ngStyle]="{ 'background-color' : ShopForm.value.CustomColourThree }" [(colorPicker)]="ShopForm.value.CustomColourThree" cpOutputFormat="hex" cpAlphaChannel="disabled"></div>
                  </div>
                </div>
                <div>
                  <div>
                    <div><input maxlength="30" type="text" pInputText formControlName="CustomLabelFour" placeholder="{{'bikeshop.shop_profile.change_status_label' | translate}}" /></div>
                    <div *ngIf="ShopForm.value.CustomLabelFour && ShopForm.value.CustomLabelFour.trim().length > 0" class="color-picker-custom" [ngStyle]="{ 'background-color' : ShopForm.value.CustomColourFour }" [(colorPicker)]="ShopForm.value.CustomColourFour" cpOutputFormat="hex" cpAlphaChannel="disabled"></div>
                  </div>
                </div>
                <div>
                  <div>
                    <div><input maxlength="30" type="text" pInputText formControlName="CustomLabelFive" placeholder="{{'bikeshop.shop_profile.change_status_label' | translate}}" /></div>
                    <div *ngIf="ShopForm.value.CustomLabelFive && ShopForm.value.CustomLabelFive.trim().length > 0" class="color-picker-custom" [ngStyle]="{ 'background-color' : ShopForm.value.CustomColourFive }" [(colorPicker)]="ShopForm.value.CustomColourFive" cpOutputFormat="hex" cpAlphaChannel="disabled"></div>
                  </div>
                </div>
                <div>
                  <div>
                    <div><input maxlength="30" type="text" pInputText formControlName="CustomLabelSix" placeholder="{{'bikeshop.shop_profile.change_status_label' | translate}}" /></div>
                    <div *ngIf="ShopForm.value.CustomLabelSix && ShopForm.value.CustomLabelSix.trim().length > 0" class="color-picker-custom" [ngStyle]="{ 'background-color' : ShopForm.value.CustomColourSix }" [(colorPicker)]="ShopForm.value.CustomColourSix" cpOutputFormat="hex" cpAlphaChannel="disabled"></div>
                  </div>
                </div>
                <div>
                  <div>
                    <div><input maxlength="30" type="text" pInputText formControlName="CustomLabelSeven" placeholder="{{'bikeshop.shop_profile.change_status_label' | translate}}" /></div>
                    <div *ngIf="ShopForm.value.CustomLabelSeven && ShopForm.value.CustomLabelSeven.trim().length > 0" class="color-picker-custom" [ngStyle]="{ 'background-color' : ShopForm.value.CustomColourSeven }" [(colorPicker)]="ShopForm.value.CustomColourSeven" cpOutputFormat="hex" cpAlphaChannel="disabled"></div>
                  </div>
                </div>
                <div>
                  <div>
                    <div><input maxlength="30" type="text" pInputText formControlName="CustomLabelEight" placeholder="{{'bikeshop.shop_profile.change_status_label' | translate}}" /></div>
                    <div *ngIf="ShopForm.value.CustomLabelEight && ShopForm.value.CustomLabelEight.trim().length > 0" class="color-picker-custom" [ngStyle]="{ 'background-color' : ShopForm.value.CustomColourEight }" [(colorPicker)]="ShopForm.value.CustomColourEight" cpOutputFormat="hex" cpAlphaChannel="disabled"></div>
                  </div>
                </div>
                <div>
                  <div>
                    <div><input maxlength="30" type="text" pInputText formControlName="CustomLabelNine" placeholder="{{'bikeshop.shop_profile.change_status_label' | translate}}" /></div>
                    <div *ngIf="ShopForm.value.CustomLabelNine && ShopForm.value.CustomLabelNine.trim().length > 0" class="color-picker-custom" [ngStyle]="{ 'background-color' : ShopForm.value.CustomColourNine }" [(colorPicker)]="ShopForm.value.CustomColourNine" cpOutputFormat="hex" cpAlphaChannel="disabled"></div>
                  </div>
                </div>
              </div>

              <!--<div class="col-md-4 label">
    {{ "bikeshop.shop_profile.custom_status_label" | translate }}:
  </div>
  <div class="col-md-2">
    <div class="p-inputgroup">
      <input type="text" pInputText formControlName="INeedHelpLabel" />
    </div>
  </div>
  <div class="col-md-1 flex" *ngIf="ShopForm.value.ShowINeedHelp" style="margin-left: -24px">
    <div class="color-picker-custom" [ngStyle]="{ 'background-color' : INeedHelpColor }" [(colorPicker)]="INeedHelpColor"></div>
  </div>-->
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.show_technicians_legend_calendar" | translate }}:
              </div>
              <div class="col-md-1">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="ShowTechnicianLegendCalendar"></p-inputSwitch>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.set_hourly_labour_goals_for_techncians" | translate }}:
              </div>
              <div class="col-md-1">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="ShowLabourGoals" (onChange)="toggleDailyGoals($event)"></p-inputSwitch>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.show_labour_totals_on_calendar_slide_out" | translate }}:
              </div>
              <div class="col-md-1">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="ShowLabourTotalsCalendar"></p-inputSwitch>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.show_total_workshop_revenue_on_calendar_slide_out" | translate }}:
              </div>
              <div class="col-md-1">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="ShowWorkshopTotalsCalendar"></p-inputSwitch>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.show_original_date_on_calender" | translate }}:
              </div>
              <div class="col-md-1">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="ShowOriginalDateOnCalendar"></p-inputSwitch>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.show_bike_type_on_calendar_card" | translate }}:
              </div>
              <div class="col-md-1">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="ShowBikeTypeOnCalendar"></p-inputSwitch>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.calendar_day_view_time_interval" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="radio-group flex">
                  <div class="p-field-radiobutton">
                    <p-radioButton value="00:05:00" label="{{ 'bikeshop.shop_profile.5_minutes' | translate }}" formControlName="DefaultDayViewTimeInterval"></p-radioButton>
                  </div>
                  <div class="p-field-radiobutton" style="margin-left: 16px;">
                    <p-radioButton value="00:15:00" label="{{ 'bikeshop.shop_profile.15_minutes' | translate }}" formControlName="DefaultDayViewTimeInterval"></p-radioButton>
                  </div>
                  <div class="p-field-radiobutton" style="margin-left: 16px;">
                    <p-radioButton value="00:30:00" label="{{ 'bikeshop.shop_profile.30_minutes' | translate }}" formControlName="DefaultDayViewTimeInterval"></p-radioButton>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Technician Goals Section -->
          <div class="settings-section" *ngIf="activeSection === 'technician-goals'">
            <div class="section-header">
              <h3>{{ "bikeshop.shop_profile.technician_hourly_labour_goals" | translate }}</h3>
            </div>

            <div *ngFor="let technician of technicians" class="row margin-top-8">
              <div class="col-md-4 label">
                {{technician.Firstname}} {{technician.Surname}}
              </div>
              <div class="col-md-2">
                <input type="number" pInputText [(ngModel)]="technician.DailyValueGoal" [disabled]="!ShopForm.value.ShowLabourGoals" [ngModelOptions]="{standalone: true}" placeholder="{{ 'bikeshop.shop_profile.hourly_labour_goal' | translate }}" />
              </div>
            </div>
          </div>

          <!-- Job Card Options Section -->
          <div class="settings-section" *ngIf="activeSection === 'jobcard-options'">
            <div class="section-header">
              <h3>{{ "bikeshop.shop_profile.jobcard_options" | translate }}</h3>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.use_new_jobcard" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="UseNewJobCard"></p-inputSwitch>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.enable_workshop_timers" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="EnableWorkshopTimer"></p-inputSwitch>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.allow_multi_quote_options" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="AllowMultipleQuoteOptions"></p-inputSwitch>
                  <small style="margin-left: 8px; margin-top: auto; margin-bottom: auto;">
                    {{ "bikeshop.shop_profile.allow_multi_quote_options_info" | translate }}
                  </small>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.allow_exact_matching_on_quote" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="AllowExactMatchingOnQuote"></p-inputSwitch>
                  <small style="margin-left: 8px; margin-top: auto; margin-bottom: auto;">
                    {{ "bikeshop.shop_profile.allow_exact_matching_on_quote_info" | translate : {email: partner.eMail} }}
                  </small>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.allow_quote_to_update_service_types" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="AllowQuoteToUpdateServiceTypes"></p-inputSwitch>
                  <small style="margin-left: 8px; margin-top: auto; margin-bottom: auto;">
                    {{ "bikeshop.shop_profile.allow_quote_to_update_service_types_info" | translate }}
                  </small>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">{{ "bikeshop.shop_profile.show_line_item_notes_quote" | translate }}:</div>
              <div class="col-md-1">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="ShowLineItemNotesOnJobcard"></p-inputSwitch>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.bike_is_here_default" | translate }}:
              </div>
              <div class="col-md-1">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="BikeIsHereDefault"></p-inputSwitch>
                </div>
              </div>
            </div>

            <div class="row margin-top-8" *ngIf="partner.POSSystemID === 6">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.use_inventory_notes_on_line_item" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="UseLineItemNotesFromPOS"></p-inputSwitch>
                  <small style="margin-left: 8px; margin-top: auto; margin-bottom: auto;">
                    {{ "bikeshop.shop_profile.use_inventory_notes_on_line_item_info" | translate }}
                  </small>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.override_created_by_on_booking" | translate }}:
              </div>
              <div class="col-md-1">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="CreatedByOverrideOnBooking"></p-inputSwitch>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.open_print_job_card_after_booking" | translate }}:
              </div>
              <div class="col-md-1">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="OpenPrintOnNewJob"></p-inputSwitch>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.allow_third_party_partners_on_jobcard" | translate }}:
              </div>
              <div class="col-md-1">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="AllowThirdPartyPartnersOnJobCard"></p-inputSwitch>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.open_tab_when_using_schedule_and_open" | translate }}:
              </div>
              <div class="col-md-2">
                <div class="p-inputgroup">
                  <p-dropdown [options]="defaultQuoteTabOptions" formControlName="OpenTabOnScheduleAndOpen"></p-dropdown>
                </div>
              </div>
            </div>

            <div class="row margin-top-8" *ngIf="partner.POSSystemID === 6">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.disable_auto_collect" | translate }}:
              </div>
              <div class="col-md-1">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="DisableAutoCollect"></p-inputSwitch>
                </div>
              </div>
            </div>

            <div id="lockSetting" class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.lock_job_card_on_collection" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <p-inputSwitch styleClass="lock-job-card-switch" formControlName="LockJobCardOnCollection"></p-inputSwitch>
                  <small style="margin-left: 8px; margin-top: auto; margin-bottom: auto;">
                    {{ "bikeshop.shop_profile.lock_job_card_on_collection_info" | translate }}
                  </small>
                </div>
              </div>
            </div>

            <div class="row margin-top-8" *ngIf="partner.POSSystemID === 6">
              <div class="col-md-4 label margin-top-8">
                {{ "bikeshop.shop_profile.custom_pos_open_url" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <input type="text" pInputText formControlName="POSCustomURL" />
                </div>
                <small>{{ "bikeshop.shop_profile.custom_pos_open_url_placeholder" | translate }}</small>
              </div>
            </div>
          </div>

          <!-- Collection Options Section -->
          <div class="settings-section" *ngIf="activeSection === 'collection-options'">
            <div class="section-header">
              <h3>{{ "bikeshop.shop_profile.collection_options" | translate }}</h3>
            </div>

            <div class="row margin-top-16">
              <div class="col-md-4 label">
                {{ 'bikeshop.shop_profile.collections.collection_service_buffer_days' | translate }}
              </div>
              <div class="col-md-3 flex">
                <div style="width: 100%">
                  <p-slider formControlName="CollectionServiceBufferDays" [min]="1" [max]="14"></p-slider>
                </div>
              </div>
              <div class="col-md-1 flex label">
                {{ShopForm.value.CollectionServiceBufferDays}} {{ ShopForm.value.CollectionServiceBufferDays === 1 ? ('bikeshop.calendar.day' | translate) : ('bikeshop.users.days' | translate)}}
              </div>
            </div>

            <div class="row">
              <div class="col-md-4"></div>
              <div class="col-md-8 flex label">
                <div class="explanation" innerHTML="{{ 'bikeshop.shop_profile.collections.collection_service_buffer_days_explanation' | translate }}"></div>
              </div>
            </div>
          </div>

          <!-- Special Orders Section -->
          <div class="settings-section" *ngIf="activeSection === 'special-orders' && (partner.POSSystemID === 6|| partner.POSSystemID === 9)">
            <div class="section-header">
              <h3>{{ "bikeshop.shop_profile.special_orders" | translate }}</h3>
            </div>

            <div class="row margin-top-8" *ngIf="partner.POSSystemID === 6 || partner.POSSystemID === 9">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.integrate_special_orders" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="RequestOrder"></p-inputSwitch>
                  <small style="margin-left: 8px; margin-top: auto; margin-bottom: auto;">
                    {{ "bikeshop.shop_profile.integrate_special_orders_info" | translate : {email: partner.eMail} }}
                  </small>
                </div>
              </div>
            </div>

            <div class="row margin-top-8" *ngIf="(partner.POSSystemID === 6 || partner.POSSystemID === 9) && externalIntegrationOptions && externalIntegrationOptions.length > 0 && ShopForm.value.RequestOrder">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.integrate_external_product_supplier" | translate }}:
              </div>
              <div class="col-md-3 label">
                <div *ngFor="let integrationOption of externalIntegrationOptions" class="integration-option">
                  <span>{{integrationOption.Name}}</span>
                  <p-inputSwitch [(ngModel)]="integrationOption.Enabled" [ngModelOptions]="{standalone: true}"></p-inputSwitch>
                </div>
              </div>
              <div class="col-md-5 label">
                <small>
                  {{ "bikeshop.shop_profile.integrate_external_product_supplier_info" | translate : {email: partner.eMail} }}
                </small>
              </div>
            </div>
          </div>

          <!-- Inventory Management Section -->
          <div class="settings-section" *ngIf="activeSection === 'inventory-management'">
            <div class="section-header">
              <h3>{{ "bikeshop.shop_profile.inventory_management" | translate }}</h3>
            </div>

            <div class="row margin-top-8" *ngIf="partner.POSSystemID === 6 || partner.POSSystemID === 9 || partner.POSSystemID === 14">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.manage_stock" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="ManageStock"></p-inputSwitch>
                  <small style="margin-left: 8px; margin-top: auto; margin-bottom: auto;">
                    <!--{{ "bikeshop.shop_profile.manage_stock_info" | translate }}:-->
                  </small>
                </div>
              </div>
            </div>

            <div class="row margin-top-8" *ngIf="partner.POSSystemID === 6 && ShopForm.value.ManageStock">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.readjust_stock_on_send_top_pos" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="AddStockBackAtSendToPOS"></p-inputSwitch>
                  <small style="margin-left: 8px; margin-top: auto; margin-bottom: auto;">
                    {{ "bikeshop.shop_profile.readjust_stock_on_send_top_pos_info" | translate }}:
                  </small>
                </div>
              </div>
            </div>

            <div class="row margin-top-8" *ngIf="partner.POSSystemID === 6 && ShopForm.value.ManageStock">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.reconcile_stock_on_complete_cancel" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="EnableInventoryManagementCorrectService"></p-inputSwitch>
                  <small style="margin-left: 8px; margin-top: auto; margin-bottom: auto;">
                    {{ "bikeshop.shop_profile.reconcile_stock_on_complete_cancel_info" | translate }}
                  </small>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "settings.othersettings.allow_transfers" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="AllowItemTransfers"></p-inputSwitch>
                  <small style="margin-left: 8px; margin-top: auto; margin-bottom: auto;">
                    {{ "customer.item.edit_item.transfer.description" | translate }}
                  </small>
                </div>
              </div>
            </div>
          </div>

          <!-- Printing Options Section -->
          <div class="settings-section" *ngIf="activeSection === 'printing-options'">
            <div class="section-header">
              <h3>{{ "bikeshop.shop_profile.printing_options" | translate }}</h3>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.print_show_logo" | translate }}:
              </div>
              <div class="col-md-1">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="Print_ShowLogo"></p-inputSwitch>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.print_show_checklist" | translate }}:
              </div>
              <div class="col-md-1">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="Print_ShowChecklist"></p-inputSwitch>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.print_show_lineitembarcode" | translate }}:
              </div>
              <div class="col-md-1">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="Print_ShowLineItemBarcode"></p-inputSwitch>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.print_show_showonlypreservicecheck" | translate }}:
              </div>
              <div class="col-md-1">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="Print_ShowOnlyPreServiceCheck"></p-inputSwitch>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.print_show_quote" | translate }}:
              </div>
              <div class="col-md-1">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="Print_ShowQuote"></p-inputSwitch>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.print_terms" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <input type="text" pInputText formControlName="PrintOutTerms" />
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.print_qr_code" | translate }}:
              </div>
              <div class="col-md-2" *ngIf="ShopForm.value.PrintOutQRImageURL">
                <div class="qr-code-image-preview">
                  <img [src]="ShopForm.value.PrintOutQRImageURL">
                  <div><daz-icon name="cross" size="16px" color="#EE3158" (click)="ShopForm.value.PrintOutQRImageURL=''"></daz-icon></div>
                </div>
              </div>
              <div class="col-md-6 flex">
                <div>
                  <button pButton type="button" class="alternate full-width" label="{{ 'bikeshop.shop_profile.upload_qr_code' | translate }}" (click)="qrCodeFileUploader.click()"></button>
                  <input #qrCodeFileUploader type="file" style="display: none" (change)="qrCodeUploader($event)">
                </div>
                <div><small>{{ 'bikeshop.shop_profile.upload_qr_code_info' | translate }}</small></div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">{{ "bikeshop.shop_profile.print_show_quoteQRCode" | translate }}:</div>
              <div class="col-md-1">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="PrintJobcardQRCode"></p-inputSwitch>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">{{ "bikeshop.shop_profile.show_jobcard_barcode" | translate }}:</div>
              <div class="col-md-1">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="ShowJobCardBarcode"></p-inputSwitch>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">{{ "general.headers.status" | translate }}:</div>
              <div class="col-md-1">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="ShowJobCardStatus"></p-inputSwitch>
                </div>
              </div>
            </div>
          </div>

          <!-- ShopRide Options Section -->
          <div class="settings-section" *ngIf="activeSection === 'shopride-options'">
            <div class="section-header">
              <h3>{{ "bikeshop.shop_profile.shopride_options" | translate }}</h3>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.shopride_options_enable_daily_summary_report" | translate }}
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <p-inputSwitch formControlName="EnableDailyShoprideSummary"></p-inputSwitch>
                  <small style="margin-left: 8px; margin-top: auto; margin-bottom: auto;">
                    {{ "bikeshop.shop_profile.shopride_options_enable_daily_summary_report_info" | translate : {email: partner.eMail} }}
                  </small>
                </div>
              </div>
            </div>

            <div class="row margin-top-8">
              <div class="col-md-4 label">
                {{ "bikeshop.shop_profile.shopride_options_send_daily_summary_time" | translate }}:
              </div>
              <div class="col-md-8">
                <div class="p-inputgroup">
                  <p-dropdown formControlName="DailyShoprideSummaryReminderTime" [options]="timeOptions" [showClear]="false" placeholder="{{ 'general.select_time' | translate }}" styleClass="ml-2 w-10rem">
                    <ng-template pTemplate="selectedItem">
                      {{ formatHourForDisplay(ShopForm.value.DailyShoprideSummaryReminderTime) }}
                    </ng-template>
                  </p-dropdown>

                  <small style="margin-left: 8px; margin-top: auto; margin-bottom: auto;">
                    {{ "bikeshop.shop_profile.shopride_options_send_daily_summary_time_info" | translate : {email: partner.eMail} }}
                  </small>
                </div>
              </div>
            </div>
          </div>

          <!-- Save Button -->
          <div class="row margin-top-16">
            <div class="col-md-4"></div>
            <div class="col-md-4">
              <button type="submit" class="iso-round-button" [disabled]="!ShopForm.valid || busy">
                {{'bikeshop.modal.shared.service_replacement_setup.button.save_changes' | translate}}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
<p-confirmDialog></p-confirmDialog>
